import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { Articoli } from 'src/app/models/articoli';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import notify from 'devextreme/ui/notify';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ProposteGestioneService } from 'src/app/shared/services/proposte-gestione.service';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxNumberBoxComponent,
  DxTextAreaComponent,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';

@Component({
  selector: 'app-articolo-detail',
  templateUrl: './articolo-detail.component.html',
  styleUrls: ['./articolo-detail.component.scss'],
  imports: [
    DxTextBoxComponent,
    DxButtonComponent,
    DxLookupComponent,
    DxTextAreaComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent,
    DxCheckBoxComponent,
    DxNumberBoxComponent,
    DxLoadPanelComponent,
  ],
})
export class ArticoloDetailComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private nS = inject(NavigatorService);
  private articoliService = inject(ArticoliService);
  private tipiArtService = inject(TipiArticoliService);
  private proGestService = inject(ProposteGestioneService);
  articolo: Articoli;
  listTipiArticoli: TipiArticoli[];
  visibleLoadPanel = false;
  showAvvisoDaCompletare = false;
  showAvvisoDaSostituire = false;

  activeTab = 'dettaglio-dip';

  ngOnInit() {
    const idArticoloParam = this.route.snapshot.paramMap.get('idArticolo');
    if (idArticoloParam == null || idArticoloParam == '0') {
      this.nS.goToArticoli();
    }

    //Dettaglio pratica
    this.loadArticolo(+idArticoloParam);
    this.loadLookups();
    this.loadProposteGestione(+idArticoloParam);
  }

  loadLookups() {
    this.tipiArtService
      .getListTipiArticoliTemp()
      .subscribe((dati) => (this.listTipiArticoli = dati));
  }

  loadProposteGestione(idArticolo) {
    this.proGestService.search({ idArticolo: idArticolo }).subscribe({
      next: (dati) => {
        this.showAvvisoDaCompletare =
          dati.filter((p) => p.tipo == 'N').length > 0;
        if (dati.filter((p) => p.tipo == 'O').length > 0) {
          this.showAvvisoDaSostituire = true;
        }
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento proposte gestione', 'warning');
        }
      },
    });
  }

  loadArticolo(idArticolo) {
    this.visibleLoadPanel = true;
    this.articoliService.get(idArticolo).subscribe({
      next: (dati) => {
        this.visibleLoadPanel = false;
        this.articolo = dati;
      },
      error: (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento articolo', 'warning');
        }
      },
    });
  }

  onBtnSalvaArticolo() {
    this.visibleLoadPanel = true;
    this.articoliService.update(this.articolo.id, this.articolo).subscribe({
      next: (dati) => {
        this.articoliService.listTemp(true).subscribe();
        this.visibleLoadPanel = false;
        this.articolo = dati;
        this.loadProposteGestione(this.articolo.id);
        notify('Articolo aggiornato correttamente', 'success');
      },
      error: (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore aggiornamento articolo', 'warning');
        }
      },
    });
  }

  getDescrExprTipologia(item) {
    if (item) {
      return item.categoria?.descrizione + ' - ' + item.descrizione;
    }
    return '';
  }
}
